import { HardDriveDownload } from 'lucide-react';
import { Card } from '../../components/ui';
import { useT } from '../../i18n';
import { canSaveOffline } from '../../offline/hooks';
import { InstallForOfflineBanner } from '../../offline/InstallForOfflineBanner';
import { PackButton } from '../../offline/SaveOfflineButton';

/** "Vista allt mitt" on top of the A–Ö list (or the Home-Screen hint where saving is not offered). */
export function SaveAllCard() {
  const t = useT();
  if (!canSaveOffline()) return <InstallForOfflineBanner />;
  return (
    <Card className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center md:px-5">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <span className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-[var(--accent-soft)] text-[var(--accent)]">
          <HardDriveDownload className="size-6" aria-hidden />
        </span>
        <div className="min-w-0">
          <div className="font-semibold">{t('offline.save_all')}</div>
          <div className="text-[15px] text-[var(--muted)]">{t('offline.save_all_desc')}</div>
        </div>
      </div>
      <PackButton kind="all" refId={null} title="" label={t('offline.save_all')} size="md" className="w-full sm:w-auto" />
    </Card>
  );
}
